import { switchMap } from 'rxjs/operators';
import { Observable, Observer, BehaviorSubject } from 'rxjs';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { IHeaderDataPointConfig } from '../shelter-profile.models';
import { IHeaderData, IProfileHeaderStudent } from './profile-header.models';

@Component({
  selector: 'profile-header',
  template: require('./profile-header.component.html'),
  styles: [require('./profile-header.component.scss')],
})
export class ProfileHeaderComponent {
  @Input() currentStudent$: BehaviorSubject<IProfileHeaderStudent>;
  @Input() dataPointsConfig: IHeaderDataPointConfig;

  // Passing thru; Needed for paginator component
  @Input() currentStudentIndex: number;
  @Input() totalStudentsInFilter: number;

  // For profile to return to previous state
  @Output() exitEmitter = new EventEmitter<void>();
  @Output() indexEmitter = new EventEmitter<number>();

  public dataPoints: Array<{ key: string; value: string }>;
  public headerData$: Observable<Array<{ key: string; value: string }>>;

  ngOnInit() {
    this.headerData$ = this.currentStudent$.pipe(switchMap(this.getHeaderData.bind(this, this.dataPointsConfig)));
  }

  public exitProfile(emitter: EventEmitter<void>): void {
    emitter.emit();
  }

  public onPaginatorClick(index: number, emitter: EventEmitter<number>): void {
    emitter.emit(index);
  }

  private getHeaderData(
    dataPointConfig: IHeaderDataPointConfig,
    student: IProfileHeaderStudent,
  ): Observable<IHeaderData> {
    return Observable.create((observer: Observer<IHeaderData>) => {
      const { dataPoints, studentName: nameKey } = dataPointConfig;
      const studentName = student[nameKey];
      const studentDataPoints = this.getDataPoints(student, dataPoints);
      observer.next({ studentName, studentDataPoints }), observer.complete();
    });
  }

  private getDataPoints(
    student: IProfileHeaderStudent,
    config: Array<{ key: Function; human: Function; formatFn: Function }>,
  ): Array<{ key: string; value: string; order: number }> {
    return config.reduce((accum, { key, human, formatFn }) => {
      accum.push({ key: human(student), value: formatFn(student[key(student)]) });
      return accum;
    }, []);
  }
}
